import type { PlayerLane } from '../types/lane.ts';

/**
 * 자기 줄의 targetIdx에 새로 공개된 타일이
 * 인접 *공개* 타일과 ±1 차이인지 검사 (보너스 트리거).
 *
 * RULES.md v2 §4.4:
 * - 직전에 자기 줄에 놓은 공개 타일이 인접한 좌측 또는 우측 공개 타일과 ±1
 * - 비공개 타일은 비교 대상 아님 (값 모름)
 * - 좌/우 어느 쪽이든 인접한 *가장 가까운 공개* 타일과 비교
 */
export function isBonusTrigger(
  lane: PlayerLane,
  targetIdx: number,
  resolvedNumber: number,
): boolean {
  const slot = lane.slots[targetIdx];
  if (!slot || slot.tile.face !== 'UP' || slot.tile.resolvedNumber !== resolvedNumber) {
    return false;
  }

  // 좌측에서 가장 가까운 공개 타일
  for (let i = targetIdx - 1; i >= 0; i--) {
    const s = lane.slots[i];
    if (s && s.tile.face === 'UP' && s.tile.resolvedNumber !== null) {
      if (Math.abs(s.tile.resolvedNumber - resolvedNumber) === 1) return true;
      break; // 첫 공개 타일에서 멈춤
    }
  }

  // 우측에서 가장 가까운 공개 타일
  for (let i = targetIdx + 1; i < lane.slots.length; i++) {
    const s = lane.slots[i];
    if (s && s.tile.face === 'UP' && s.tile.resolvedNumber !== null) {
      if (Math.abs(s.tile.resolvedNumber - resolvedNumber) === 1) return true;
      break;
    }
  }

  return false;
}
